import React, { useState, useRef } from "react";

const UIPersonaFlag = (props) => {
  const [show, setShow] = React.useState(false);

  let mpersona = props.mpersona;
  let c1 = "#" + mpersona.substring(0, 6);
  let c2 = "#" + mpersona.substring(6, 12);
  let c3 = "#" + mpersona.substring(12, 18);
  let c4 = "#" + mpersona.substring(18, 24);
  let c5 = "#" + mpersona.substring(24, 30);
  let c6 = "#" + mpersona.substring(30, 32) + mpersona.substring(0, 4);
  let flag = (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "7px 7px 7px",
        gridTemplateRows: "7px 7px",
        gridGap: "0px",
        backgroundColor: "#fff",
        color: "#444",
        width: "21px",
        border: "1px solid #fff",
      }}
    >
      <div
        style={{
          backgroundColor: c1,
          color: c1,
          borderRadius: "0px",
        }}
      ></div>
      <div
        style={{
          backgroundColor: c2,
          color: c2,
          borderRadius: "0px",
        }}
      ></div>
      <div
        style={{
          backgroundColor: c3,
          color: c3,
          borderRadius: "0px",
        }}
      ></div>
      <div
        style={{
          backgroundColor: c4,
          color: c4,
          borderRadius: "0px",
        }}
      ></div>
      <div
        style={{
          backgroundColor: c5,
          color: c5,
          borderRadius: "0px",
        }}
      ></div>
      <div
        style={{
          backgroundColor: c6,
          color: c6,
          borderRadius: "0px",
        }}
      ></div>
    </div>
  );
  let hint = (
    <div style={{ backgroundColor: "#00000030", color: "#ffffff" }}>
      {props.mpersona}
    </div>
  );
  let content = (
    <div
      className="name"
      style={{
        border: "1px solid #000",
        position: "absolute",
        top: "50px",
        margin: "0px",
        padding: "0px",
      }}
      onClick={() => setShow((show) => !show)}
    >
      {show ? hint : flag}
    </div>
  );

  return content;
};

export default UIPersonaFlag;
